import React from "react";
import FontIcon from "../../Foundation/FontIcon/FontIcon";
import SvgIcon from "../../Foundation/SvgIcon/SvgIcon";
import { ArrowNavigationAnchor } from "./ArrowNavigation.styled";

export interface IArrowNavigationProps
  extends React.AnchorHTMLAttributes<HTMLElement> {
  direction?: "right" | "left";
  mode?: "light" | "dark";
  disabled?: boolean;
  as?: string | React.ComponentType<any>;
}

const ArrowNavigation: React.FC<IArrowNavigationProps> = (props) => {
  const { direction = "left", disabled, ...rest } = props;
  return (
    <ArrowNavigationAnchor direction={direction} $disabled={disabled} {...rest}>
      <FontIcon
        className="arrow-icon"
        icon={direction === "left" ? "arrow_small_left" : "arrow_small_right"}
      />
    </ArrowNavigationAnchor>
  );
};

export default ArrowNavigation;
